import {useContext} from 'react'
import {SalesRepTypeReportContext} from '../../context'
import {DynamicTable} from '../../../../components/DynamicTable'
import {SALES_REP_TYPE_REPORT_COLUMNS} from '../../utils'
import SalesRepTypeReportRow from './SalesRepTypeReportRow'
import {parseSalesRepTypeReportRow} from '../../parsings'
import {formatPrice} from '../../../../utils/common'

const SalesRepTypeReportTable = () => {
  const {
    salesRepTypeData,
    isSalesRepTypeLoading,
    salesRepTypeFilters,
    onSalesRepTypeSortingChange,
  } = useContext(SalesRepTypeReportContext)

  return (
    <DynamicTable
      data={salesRepTypeData}
      sortableColumns={SALES_REP_TYPE_REPORT_COLUMNS}
      loading={isSalesRepTypeLoading}
      TableRow={SalesRepTypeReportRow}
      noDataMessage='No sales rep type reports found'
      tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
      rowParsingFunction={parseSalesRepTypeReportRow}
      filters={salesRepTypeFilters}
      onSortingChange={onSalesRepTypeSortingChange}
      tableFooter={({columnTotals}: any) => (
        <tfoot className='border-top border-gray-200 text-dark fw-bolder'>
          <tr>
            <td>TOTAL</td>
            <td>{columnTotals?.total_order_count}</td>
            <td>{formatPrice(columnTotals.total_shipping, false)}</td>
          </tr>
        </tfoot>
      )}
    />
  )
}

export default SalesRepTypeReportTable
